import React from 'react';

import AppLayoutView from './App.layout.view';

export const AppLayout = ({ children }) => (
  <AppLayoutView>{children}</AppLayoutView>
);
